import React, { useEffect, useRef } from 'react';
import { Typography } from '@mui/material';

const EditableText = ({ value = '', editable = false, onChange, component = 'div', sx, ...props }) => {
  const editorRef = useRef(null);

  /**
   * React state -> DOM
   *
   * contentEditable should not be controlled directly by React.
   * Otherwise every onInput -> setState -> render can reset
   * innerHTML and cause the cursor / selection to jump.
   */
  useEffect(() => {
    const el = editorRef.current;

    if (!el) return;

    /**
     * Don't overwrite DOM while the user is editing.
     *
     * This is the key to preventing cursor jumping.
     */
    if (el.contains(document.activeElement)) {
      return;
    }

    const nextHtml = value || '';

    if (el.innerHTML !== nextHtml) {
      el.innerHTML = nextHtml;
    }
  }, [value]);

  const handleInput = event => {
    const html = event.currentTarget.innerHTML;

    onChange?.(html);
  };

  return (
    <Typography
      {...props}
      ref={editorRef}
      component={component}
      contentEditable={editable}
      onInput={handleInput}
      sx={sx}
    />
  );
};

export default EditableText;
